```vue
<template>
  <div class="container">
    <!-- Loading Bar -->
    <div v-if="isLoading" class="loading-bar">
      <div class="loading-progress"></div>
    </div>
    <div class="top_part">
      <div class="part_left">
        <div class="btn1">
          <button @click="printPage">Imprimer</button>
        </div>
        <div class="btn1">
          <select @change="sortParoisse(); searchInDbDistrict()" v-model="conference_select" id="">
            <option selected value="">--CONFERENCE--</option>
            <option v-for="conf in conferences" :key="conf.id" :value="conf.id">{{ conf.nom_conference }}</option>
          </select>
        </div>
        <div class="btn1">
          <select @change="searchInDbParoisse" v-model="form.id_paroisse" name="" id="">
            <option selected value="">--PAROISSE--</option>
            <option v-for="par in paroisses" :key="par.id" :value="par.id">{{ par.nom_paroisse }}</option>
          </select>
        </div>
        <div class="btn1">
          <input @change="dateDebut" v-model="date_debut" class="select_" type="date" name="" id="">
        </div>
        <div class="btn1">
          <input class="select_" @change="dateFin" v-model="date_fin" type="date" name="" id="">
        </div>
        <div class="search_btn">
          <button @click="searchInDBAll">Valider</button>
        </div>
        <div class="search">
          <input v-model="inputSearch" type="text" placeholder="Rechercher...">
        </div>
      </div>
      <div class="part_right">
        <div class="add_btn">
          <button @click="dialog = true; modifier = false">+</button>
        </div>
      </div>
    </div>
    <div class="table_content">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Nom</th>
            <th>Prenom</th>
            <th>Conference</th>
            <th>Paroisse</th>
            <th>Age</th>
            <th>Categorie</th>
            <th>Debut Ministere</th>
            <th>Status</th>
            <th colspan="3">Options</th>
          </tr>
        </thead>
        <tbody class="er">
          <tr class="spacer">
            <td colspan="100"></td>
          </tr>
          <tr v-if="filteredMembres.length === 0">
            <td colspan="10" class="no-data">
              <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 17H17V15H7V17ZM7 13H17V11H7V13ZM7 9H17V7H7V9Z" fill="#999"/>
              </svg>
              <p>Pas de données disponibles</p>
            </td>
          </tr>
          <tr v-else v-for="membre in filteredMembres" :key="membre.matricule_membre">
            <td>{{ membre.matricule_membre }}</td>
            <td>{{ membre.nom_membre }}</td>
            <td>{{ membre.prenom_membre }}</td>
            <td>{{ membre.nom_conference }}</td>
            <td>{{ membre.paroisse[0]?.nom_paroisse || 'N/A' }}</td>
            <td>{{ ageCal(membre.date_naissance_membre) }} Ans</td>
            <td>{{ membre.categorie[0]?.nom_categorie || 'N/A' }}</td>
            <td>{{ datetime(membre.debut_ministere_membre) }}</td>
            <td>
              <div :class="membre.statut" class="status">{{ membre.statut }}</div>
            </td>
            <td><button @click="edit_membre(membre)" id="mod_btn">Modifier</button></td>
            <td>
              <button id="info_btn" @click="more_info(membre)">
                Voir Plus <i class="bx bx-dots-horizontal-rounded"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pagination Controls -->
    <div class="pagination" v-if="pagination.last_page > 1">
      <button @click="changePage(pagination.current_page - 1)" :disabled="pagination.current_page === 1">Precedent</button>
      <button @click="changePage(1)" :class="{ active: pagination.current_page === 1 }">1</button>
      <span v-if="pagination.current_page > 4">...</span>
      <button
        v-for="page in paginationPages"
        :key="page"
        @click="changePage(page)"
        :class="{ active: pagination.current_page === page }"
      >{{ page }}</button>
      <span v-if="pagination.current_page < pagination.last_page - 3">...</span>
      <button
        v-if="pagination.last_page > 1"
        @click="changePage(pagination.last_page)"
        :class="{ active: pagination.current_page === pagination.last_page }"
      >{{ pagination.last_page }}</button>
      <button @click="changePage(pagination.current_page + 1)" :disabled="pagination.current_page === pagination.last_page">
        Suivant
      </button>
    </div>
    <add_membre @getMembres="getMembres" :edit_membre="modifier" @close="close" v-if="dialog"></add_membre>
    <cotisation_modal @getMembres="getMembres" @close="close" v-if="dialog_cotisation"></cotisation_modal>
  </div>
  <div class="printCode">
    <div class="container">
      <div class="paper">
        <div class="header">
          <div class="left">
            <h2>EGLISE METHODISTE LIBRE AU BURUNDI</h2>
            <h2>Conference General</h2>
            <h2>Departement des pensions</h2>
          </div>
          <div class="title">
            <h2>LISTE DES MEMBRES</h2>
          </div>
        </div>
        <div class="body">
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th>MATRICULE</th>
                  <th>NOM</th>
                  <th>PRENOM</th>
                  <th>CONFERENCE</th>
                  <th>PAROISSE</th>
                  <th>CATEGORIE</th>
                  <th>STATUT</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="filteredMembres.length === 0">
                  <td colspan="7" class="no-data">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 17H17V15H7V17ZM7 13H17V11H7V13ZM7 9H17V7H7V9Z" fill="#999"/>
                    </svg>
                    <p>Pas de données disponibles</p>
                  </td>
                </tr>
                <tr v-else v-for="membre in filteredMembres" :key="membre.matricule_membre">
                  <td>{{ membre.matricule_membre }}</td>
                  <td>{{ membre.nom_membre }}</td>
                  <td>{{ membre.prenom_membre }}</td>
                  <td>{{ membre.nom_conference }}</td>
                  <td>{{ membre.paroisse[0]?.nom_paroisse || 'N/A' }}</td>
                  <td>{{ membre.categorie[0]?.nom_categorie || 'N/A' }}</td>
                  <td>
                    <div :class="membre.statut" class="status">{{ membre.statut }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { format } from 'date-fns';
import { debounce } from 'lodash';
import add_membre from '../components/membres/modals/add_membre.vue';
import cotisation_modal from '../components/cotisations/modals/form_cotisation.vue';

export default {
  components: {
    add_membre,
    cotisation_modal,
  },
  data() {
    return {
      modifier: false,
      dialog: false,
      dialog_cotisation: false,
      inputSearch: '',
      conference_select: '',
      conferences: [],
      date_debut: '',
      date_fin: '',
      form: {
        id_paroisse: '',
      },
      paroisses: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        from: 0,
        to: 0,
        total: 0,
      },
      isLoading: false,
      // url: process.env.VUE_APP_API_URL || 'http://localhost:8000/api/',
    };
  },
  methods: {
    printPage() {
      window.print();
    },
    validateDates() {
      if (!this.date_debut || !this.date_fin) {
        return true; // Allow search if one or both dates are not set
      }
      const startDate = new Date(this.date_debut);
      const endDate = new Date(this.date_fin);
      if (startDate > endDate) {
        this.$toast.error('La date de début doit être antérieure ou égale à la date de fin');
        return false;
      }
      return true;
    },
    searchInDBAll: debounce(async function (page = 1) {
      if (!this.validateDates()) {
        return;
      }
      this.isLoading = true;
      try {
        const params = {
          conference_select: this.conference_select || undefined,
          id_paroisse: this.form.id_paroisse || undefined,
          page: page,
        };
        if (this.date_debut && this.date_fin) {
          params.date_debut = this.date_debut;
          params.date_fin = this.date_fin;
        }
        const res = await axios.get(this.url + 'membres', { params });
        this.$store.state.membres = res.data.data || [];
        this.pagination = {
          current_page: res.data.current_page || 1,
          last_page: res.data.last_page || 1,
          from: res.data.from || 0,
          to: res.data.to || 0,
          total: res.data.total || 0,
        };
        if (this.date_debut && this.date_fin && res.data.data.length === 0) {
          this.$toast.info('Aucun membre trouvé pour l\'intervalle de dates sélectionné');
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erreur lors de la recherche des membres');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    searchInDbDistrict: debounce(async function (page = 1) {
      this.isLoading = true;
      try {
        const res = await axios.get(this.url + 'membres', {
          params: {
            conference_select: this.conference_select || undefined,
            page: page,
          },
        });
        this.$store.state.membres = res.data.data || [];
        this.pagination = {
          current_page: res.data.current_page || 1,
          last_page: res.data.last_page || 1,
          from: res.data.from || 0,
          to: res.data.to || 0,
          total: res.data.total || 0,
        };
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erreur lors de la recherche par district');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    searchInDbParoisse: debounce(async function (page = 1) {
      this.isLoading = true;
      try {
        const res = await axios.get(this.url + 'membres', {
          params: {
            id_paroisse: this.form.id_paroisse || undefined,
            page: page,
          },
        });
        this.$store.state.membres = res.data.data || [];
        this.pagination = {
          current_page: res.data.current_page || 1,
          last_page: res.data.last_page || 1,
          from: res.data.from || 0,
          to: res.data.to || 0,
          total: res.data.total || 0,
        };
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erreur lors de la recherche par paroisse');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    sortParoisse: debounce(async function () {
      this.isLoading = true;
      try {
        const res = await axios.get(this.url + 'paroisses?conference_select=' + this.conference_select);
        this.$store.state.paroisses = res.data || [];
        this.paroisses = this.conference_select ? res.data : [];
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erreur lors du chargement des paroisses');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    dateDebut() {
      if (this.date_debut && this.date_fin) {
        this.searchInDBAll();
      }
    },
    dateFin() {
      if (this.date_debut && this.date_fin) {
        this.searchInDBAll();
      }
    },
    datetime(date) {
      return date ? format(new Date(date), 'dd/MM/yyyy') : 'N/A';
    },
    close() {
      this.dialog = false;
      this.dialog_cotisation = false;
    },
    getMembres: debounce(async function (page = 1) {
      this.isLoading = true;
      try {
        const res = await axios.get(this.url + 'membres', { params: { page: page } });
        this.$store.state.membres = res.data.data || [];
        this.pagination = {
          current_page: res.data.current_page || 1,
          last_page: res.data.last_page || 1,
          from: res.data.from || 0,
          to: res.data.to || 0,
          total: res.data.total || 0,
        };
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erreur lors du chargement des membres');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    getDistricts: debounce(async function () {
      this.isLoading = true;
      try {
        const res = await axios.get(this.url + 'conferences');
        this.conferences = res.data || [];
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erreur lors du chargement des conférences');
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    }, 300),
    edit_membre(item) {
      this.dialog = true;
      this.modifier = true;
      this.$store.state.membre = item;
    },
    more_info(n) {
      this.$router.push({ name: 'info_membre', params: { id: n.matricule_membre } });
    },
    ageCal(n) {
      if (!n) return 'N/A';
      let currentDate = new Date();
      let birthdate = new Date(n);
      let difference = currentDate - birthdate;
      let age = Math.floor(difference / 31557600000);
      return age >= 0 ? age : 'N/A';
    },
    addCot(membre) {
      this.dialog_cotisation = true;
      this.$store.state.membre_cotisation = membre;
    },
    changePage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.searchInDBAll(page);
      }
    },
  },
  mounted() {
    this.getDistricts();
    this.getMembres();
  },
  computed: {
    filteredMembres() {
      return this.$store.state.membres.filter((item) => {
        const search = this.inputSearch.toLowerCase();
        return (
          (item.matricule_membre || '').toLowerCase().includes(search) ||
          (item.nom_membre || '').toLowerCase().includes(search) ||
          (item.prenom_membre || '').toLowerCase().includes(search)
        );
      });
    },
    paginationPages() {
      const pages = [];
      const current = this.pagination.current_page;
      const last = this.pagination.last_page;

      if (current === 1) {
        for (let i = 2; i <= Math.min(3, last - 1); i++) {
          pages.push(i);
        }
      } else if (current === last && last >= 3) {
        for (let i = Math.max(2, last - 2); i < last; i++) {
          pages.push(i);
        }
      } else {
        let start = Math.max(2, current - 1);
        let end = Math.min(last - 1, current + 1);
        if (end - start < 2 && last >= 4) {
          if (current <= 3) {
            end = Math.min(4, last - 1);
          } else if (current >= last - 2) {
            start = Math.max(2, last - 3);
          }
        }
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
      }
      return pages;
    },
  },
};
</script>

<style src="../assets/css/table.css" scoped></style>
<style scoped>
.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
}
.no-data svg {
  margin-bottom: 10px;
}
.no-data p {
  font-size: 16px;
  font-weight: 500;
}
.status.actif { color: black; border-radius: 20px; font-weight: 500; background-color: rgb(173, 253, 173); }
.status.abandon { color: red; }
.status.deserteur { color: orange; }
.status.pensionne { color: blue; }
.loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  z-index: 1000;
}
.loading-progress {
  height: 100%;
  background-color: #4caf50;
  width: 0;
  animation: loading 2s infinite;
}
@keyframes loading {
  0% { width: 0; }
  50% { width: 50%; }
  100% { width: 100%; }
}
</style>
```